(function () {
  var STORAGE_KEY = 'eh-theme';
  var toggle = document.querySelector('[data-theme-toggle]');
  if (!toggle) return;

  function apply(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }

  toggle.addEventListener('click', function () {
    var current = document.documentElement.getAttribute('data-theme');
    apply(current === 'dark' ? 'light' : 'dark');
  });
})();
